import DOMPurify from "dompurify";

/**
 * Plug in to set up a directive v-safe-html that sanitises HTML content
 * to make sure it is safe. A replacement for the built-in directive v-html
 */
export default defineNuxtPlugin( {
  name: "apollo-safe-html",
  parallel: true,
  setup ( nuxtApp ) {
    nuxtApp.vueApp.directive( "safe-html", {
      mounted ( el, binding ) {
        el.innerHTML = DOMPurify.sanitize( binding.value, { ADD_ATTR: ["target"] } );
      },
      updated ( el, binding ) {
        el.innerHTML = DOMPurify.sanitize( binding.value, { ADD_ATTR: ["target"] } );
      },
    } );
  },
} );
